import React from 'react'

import { useTranslation } from 'next-i18next'

import CommonButton from '@/components/form/Button/CommonButton'

import { colors } from '@/styles/theme'

import BtnGlobalCustomStyles from '@/components/form/Button/button.customStyles'

import { Container } from './MobileFiltersButtons.styled'

interface MobileFiltersButtonsProps {
  onShowResults: () => void
  onClearFilters: () => void
}

const MobileFiltersButtons: React.FC<MobileFiltersButtonsProps> = ({
  onShowResults,
  onClearFilters
}) => {
  const { t } = useTranslation('parkings')
  const translatedApplyFilters = t('searchNearParking.filters.applyFilters')

  const translatedRemoveFilters = t('searchNearParking.filters.removeFilters')
  return (
    <Container>
      <CommonButton
        variant="options"
        onClick={onShowResults}
        data-test-id="show-all-filters-button"
        customStyle={[
          BtnGlobalCustomStyles.commonBlock,
          BtnGlobalCustomStyles.showResultCommonStyles,
          BtnGlobalCustomStyles.mobileFilter
        ]}
      >
        {translatedApplyFilters}
      </CommonButton>
      <CommonButton
        variant="options"
        onClick={onClearFilters}
        data-test-id="clear-all-filters-button"
        customStyle={BtnGlobalCustomStyles.clearFilter}
      >
        {translatedRemoveFilters}
      </CommonButton>
    </Container>
  )
}

export default MobileFiltersButtons
